import React from 'react';
import ModalNotificationLicenseComponent from '../../Component/Modal/ModalNotificationLicenseComponent';

interface IProps {
  modalIsShow: boolean;
  setModalIsShow: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function ModalNotificationLicenseContainer(props: IProps) {
  const { modalIsShow, setModalIsShow } = props;

  const handleCancel = () => setModalIsShow(false);

  return (
    <ModalNotificationLicenseComponent
      modalIsShow={modalIsShow}
      handleCancel={handleCancel}
    />
  );
}
